import { Checkbox } from 'antd';

import type { ITest } from '@/api/endpoints/schools/schoolSelectionPanel';

import styles from './ReservedUserCard.module.scss';

export interface IProps {
  id: ITest['id'];
  user: ITest['user'];
  checked: boolean;
  toggleReservedUserId: (id: number) => void;
}

export const ReservedUserCard = ({
  id,
  user: { full_name: fullName, email, phone },
  checked,
  toggleReservedUserId,
}: IProps) => (
  <div
    className={styles.card}
    onClick={() => toggleReservedUserId(id)}
  >
    <Checkbox
      checked={checked}
      onChange={() => toggleReservedUserId(id)}
      onClick={(event) => event.stopPropagation()}
    />
    <div className={styles.info}>
      <p className={styles.name}>{fullName}</p>
      <p className={styles.meta}>
        <span>{email}</span>
        <span className={styles.dot}>•</span>
        <span>{phone}</span>
      </p>
    </div>
  </div>
);
